import { render, staticRenderFns } from "./TftPlay.vue?vue&type=template&id=10cc0fae&scoped=true&"
import script from "./TftPlay.vue?vue&type=script&lang=js&"
export * from "./TftPlay.vue?vue&type=script&lang=js&"
import style0 from "./TftPlay.vue?vue&type=style&index=0&id=10cc0fae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cc0fae",
  null
  
)

export default component.exports